import { FunctionComponent, useState } from "react";
import { useRecoilValue } from "recoil";
import { IAmount } from "./Amount";
import { offlineWesternUnion } from "../../../../store";
import { DownIcon, BlueDivision, Plus, Equal } from "../../../../assets/Icons";

export const PaymentDetails: FunctionComponent<IAmount.PaymentDetailsProps> = ({
  nostro,
  setNostro,
  sendAmount,
}) => {
  const transactionData: any = useRecoilValue(offlineWesternUnion);
  const selected = "rounded px-2 text-white bg-primary-1050";
  const deselcted = "rounded border px-2 text-primary-1050 bg-white";
  const [taxStep, setTaxStep] = useState<boolean>(true);
  const totalPay =
    transactionData?.total_tax +
    transactionData?.nostro_charges +
    transactionData?.nostro_charges_new +
    transactionData?.hop_fees +
    transactionData?.tcs;

  const nostroHandler = () => {
    if (nostro === "our") {
      setNostro("bene");
    } else {
      setNostro("our");
    }
  };

  return (
    <div className="w-full p-28">
      <div className="mb-10 font-normal text-black -ml-28 text-md text-[20px]">Calculation</div>
      <div className="flex items-center justify-between mb-8">
        <div className="flex flex-col flex-1 -ml-28">
          <div className="flex items-center justify-between mb-0">
            <div className="flex items-center space-x-2 text-xs font-bold text-black lg:text-base">
              <div className="mr-3 rotate-180">
                <DownIcon fillColor="rotate-90" />
              </div>
              You Send
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-bold text-black lg:text-base">{sendAmount}</div>
              <div className="text-xs font-bold text-black lg:text-base">INR</div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-8">
        <div className="bg-grey-1350 w-[30px] h-[30px] rounded-full flex justify-center items-center -ml-28">
          <BlueDivision />
        </div>
        <div className="flex items-center justify-between flex-1 ml-5">
          <div className="-ml-2 text-xs font-bold text-black lg:text-base">Exchange rate</div>
          <div className="flex items-center justify-between space-x-16">
            <div className="text-xs font-bold lg:text-base">{transactionData?.conversion_rate}</div>
            <div className="text-xs font-bold lg:text-base">INR</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-8">
        <div className="flex flex-col flex-1 -ml-28">
          <div
            onClick={() => setTaxStep(!taxStep)}
            className="flex items-center justify-between cursor-pointer hover:underline"
          >
            <div className="flex items-center text-xs font-bold text-black lg:text-base">
              <div className="mr-3">
                {taxStep === true ? <DownIcon fillColor="rotate-180" /> : <DownIcon />}
              </div>
              Taxes and fees
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-bold text-black lg:text-base">
                {totalPay?.toFixed(2) ? totalPay?.toFixed(2) : ""}
              </div>
              <div className="text-xs font-bold text-black lg:text-base">INR</div>
            </div>
          </div>
          {taxStep === true && (
            <div className="mt-6 ml-[5px] animate-fade duration-0">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  GST
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-bold text-black lg:text-base">
                    {transactionData?.total_tax}
                  </div>
                  <div className="text-xs font-bold text-black lg:text-base">INR</div>
                </div>
              </div>
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  Bank Fee
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {transactionData?.nostro_charges}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between space-x-5">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  <span>NOSTRO</span>
                  <div className="flex ml-20 cursor-pointer" onClick={nostroHandler}>
                    <div className={nostro === "our" ? selected : deselcted}>Our</div>
                    <div className={nostro === "bene" ? selected : deselcted}>Bene</div>
                  </div>
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {transactionData?.nostro_charges_new}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-[18px]">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  Vendor Fee
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {transactionData?.hop_fees}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-[18px]">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  TCS
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {transactionData?.tcs ? transactionData.tcs : 0}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="border border-gray-500 rounded-full mt-7"></div>
          <div className="flex items-center justify-between mt-8">
            <div className="flex items-center text-xs font-normal text-black lg:text-base">
              <div className="mr-3">
                <Equal />
              </div>
              <span className="font-bold text-black">You Pay</span>
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {transactionData?.total_pay}
              </div>
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">INR</div>
            </div>
          </div>
          {/* <div className="flex items-center justify-between mt-8">
            <div className="flex items-center text-xs font-normal text-black lg:text-base">
              <div className="mr-3">
                <Telegram />
              </div>
              <span className="font-bold text-black">They Receive</span>
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {transactionData?.reciepient_recieve}
              </div>
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {transactionData.dest_currency}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
